<template>
  <div class="dropdown">
    <Popper v-model:open="menuOpen" placement="bottom-end">
      <template #trigger>
        <div class="dropdown__trigger">
          <div class="select__trigger">
            <div class="select__label-wrapper">
              <span
                class="select__label"
                :aria-label="$t('aria_label.filter.label')"
              >
                {{ label }}
                <span
                  v-if="filterCount"
                  class="select__filter-count typo-tiny"
                  :aria-label="$t('aria_label.filter.count')"
                >
                  {{ filterCount }}
                </span>
              </span>
            </div>
            <div class="select__arrow">
              <UseSvg name="arrow_down_16" class="icon icon--small" />
            </div>
          </div>
        </div>
      </template>
      <div class="menu menu--dropdown menu--with-actions">
        <div class="menu__items">
          <!-- Dropdown actions -->
          <div class="menu__actions">
            <button
              class="button button--small button--light typo-ignore typo-small"
              type="button"
              @click="clearFilters"
              :aria-label="$t('aria_label.filter.clear')"
            >
              {{ $t('general.clear_selection') }}
            </button>
            <button
              class="button button--small button--primary typo-ignore typo-small"
              type="submit"
              @click="$emit('applyFilters', label, selectedOptions), (menuOpen = false)"
            >
              {{ $t('general.apply') }}
            </button>
          </div>
          <ul>
            <li
              v-for="option in options"
              :key="option.value"
              class="checkbox checkbox--small checkbox--dark menu-item typo-list-item menu-item--dropdown"
            >
              <input
                :id="option.value"
                :value="option.value"
                class="checkbox__input"
                type="checkbox"
                v-model="selectedOptions"
                :aria-label="$t('aria_label.filter.option')"
              />
              <label
                :for="option.value"
                class="checkbox__label menu-item__link"
              >
                <span class="menu-item__label">
                  {{ option.label }}
                </span>
              </label>
            </li>
          </ul>
        </div>
      </div>
    </Popper>
  </div>
</template>

<script setup>
import { ref } from 'vue';

// Components
import Popper from '@/components/generic/popper.vue';
import UseSvg from '@/components/generic/use_svg.vue';

const emit = defineEmits(['applyFilters', 'clearFilters']);
defineProps({
  filterCount: { type: Number, required: true },
  label: { type: String, required: true },
  options: { type: Array, required: true },
});

const selectedOptions = ref([]);
const menuOpen = ref(false);

function clearFilters(label) {
  emit('clearFilters', label);
  menuOpen.value = false;
  selectedOptions.value = [];
}
</script>
